<div class="dialog-header">
  <h2 mat-dialog-title class="mask-file-names">{{ data.fileName }}</h2>
  <div class="header-actions">
    @if (pdfBlob) {
      <button mat-icon-button [matTooltip]="'COMMON.ZOOM_OUT' | translate" [attr.aria-label]="'COMMON.ZOOM_OUT' | translate" (click)="zoomOut()">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button mat-icon-button [matTooltip]="'COMMON.ZOOM_IN' | translate" [attr.aria-label]="'COMMON.ZOOM_IN' | translate" (click)="zoomIn()">
        <mat-icon>zoom_in</mat-icon>
      </button>
    }
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content>
  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  } @else if (hasError) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <span>{{ 'COMMON.FAILED_TO_LOAD' | translate }}</span>
    </div>
  } @else if (pdfBlob) {
    <ngx-extended-pdf-viewer
      [src]="pdfBlob"
      [page]="1"
      [zoom]="zoomLevel ?? 'page-fit'"
      [textLayer]="true"
      [handTool]="false"
      [showToolbar]="false"
      [useInlineScripts]="false"
      [backgroundColor]="viewerBackground"
    ></ngx-extended-pdf-viewer>
  }
</mat-dialog-content>
